import React, { useState, useEffect, useRef, useCallback } from "react";
import axios from "axios";
import publicAxios from "../../utils/publicAxios";
import { useNavigate, useParams } from "react-router-dom";
import { showToast } from "../../utils/utils";
import PhoneInput from "react-phone-input-2";
import { FaEye, FaEyeSlash, FaCheck, FaInfoCircle } from "react-icons/fa";
import Footerweb from "../../components/layout/footer/Footerweb";
import Headerweb from "../../components/layout/header/Headerweb";
import companyLogo from "./../../assets/images/logo.webp";
import HappyMan from "./../../assets/images/HappyMan_modern-office.jpg";
import invoice from "./../../assets/images/invoice.png";
import approved from "./../../assets/images/approved.png";
import paid from "./../../assets/images/paid.png";
import CashFlow from "./../../assets/images/Cash-Flow-Solution.png";
import FastFunds from "./../../assets/images/Fast-Funds.png";
import SimpleEasy from "./../../assets/images/Simple-Easy.png";
import InnovativeSolution from "./../../assets/images/Innovative-Solution.png";
import sarah from "./../../assets/images/sarah.jpg";
import pranav from "./../../assets/images/pranav.jpg";
import yum from "./../../assets/images/yum-1.png";
import yum2 from "./../../assets/images/yum-2.png";

import { Link } from "react-router-dom";
import "./referenceSignup.scss";
import "./../../assets/scss/login.scss";
import "./../../assets/scss/common.scss";
import "react-phone-input-2/lib/style.css";
import NotFound from "../NotFound";
import {
  adduserModal,
  auPhNumberTag,
  footer_web,
  monthlyLending,
  nzPhNumberTag,
  passwordtext,
  profiletexts,
  referencePromoCode,
  reffPartner,
  reset_password,
  signup
} from "../../locales/en";
import {
  COUNTRY_CODE_AU_SMALL,
  DIGIT_REGEX,
  EMAIL_REGEX,
  SPECIAL_CHAR_REGEX,
  MAILTO_INFO_EMAIL,
  NUMBER_REGEX,
  PASSWORD_VALIDATION_REGEX,
  showToastType,
  UPPERCASE_REGEX
} from "../../utils/constants/appConstants";
import { getreferralImageURL } from "../../utils/constants/apiEndPoints";
import { LOGIN } from "../../route/paths";

export default function ReferenceSignUPromocode() {
  const [activeTab, setActiveTab] = useState("");

  const handleTabClick = (tabName) => {
    setActiveTab(tabName);
  };

  const initialRender = useRef(true);
  const [ipAddress, setIpAddress] = useState("");
  const [country, setCountry] = useState(COUNTRY_CODE_AU_SMALL);
  const navigate = useNavigate();
  const { referralCode } = useParams();
  const [imageBase64, setImageBase64] = useState("");
  const [fileType, setFileType] = useState("");
  const [description, setDescription] = useState("");
  const [notFound, setNotFound] = useState();
  const [isLoading, setIsLoading] = useState(true);

  const getIPAddress = async () => {
    try {
      const response = await axios.get("https://api.ipify.org?format=json");
      setIpAddress(response.data.ip);
    } catch (error) {
      console.error(referencePromoCode.errMsg.item1, error);
    }
  };

  const getCountryFromIP = async () => {
    try {
      // Replace 'ip-api' with the actual IP geolocation API you're using
      const response = await axios.get("http://ip-api.com/json");
      const detectedCountry = response.data.countryCode.toLowerCase();

      if (detectedCountry === "au" || detectedCountry === "nz") {
        setCountry(detectedCountry);
      }
    } catch (error) {
      console.error(referencePromoCode?.errMsg.item2, error);
    }
  };

  const initialValues = {
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    password: "",
    showPassword: false,
    error: ""
  };
  const [values, setValues] = useState(initialValues);

  const initialErrors = {
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    password: ""
  };
  const [errors, setErrors] = useState(initialErrors);

  const handleClickShowPassword = () => {
    setValues({ ...values, showPassword: !values.showPassword });
  };

  const handleInputChange = (field, value) => {
    setValues({ ...values, [field]: value });
    validateField(field, value);
  };

  const validateField = (field, value) => {
    let error = "";
    const currentPass = "San@1998";

    switch (field) {
      case "firstName":
        error =
          value.trim() !== "" && value.length >= 3
            ? ""
            : referencePromoCode.errMsg.item3;
        break;
      case "lastName":
        error =
          value.trim() !== "" && value.length >= 3
            ? ""
            : referencePromoCode.errMsg.item4;
        break;
      case "email":
        error = EMAIL_REGEX.test(value) ? "" : referencePromoCode.errMsg.item5;
        break;
      case "phoneNumber":
        error =
          value.trim() !== "" && NUMBER_REGEX.test(value)
            ? ""
            : referencePromoCode.errMsg.item6;
        break;
      case "password": {
        const passwordErrors = [];
        if (value.length < 8) {
          passwordErrors.push(
            <small className="mt-1 d-block">
              <FaInfoCircle /> {referencePromoCode?.errMsg.item7}
            </small>
          );
        }
        if (!DIGIT_REGEX.test(value)) {
          passwordErrors.push(
            <small className="mt-1 d-block">
              <FaInfoCircle /> {referencePromoCode?.errMsg.item8}
            </small>
          );
        }
        if (!UPPERCASE_REGEX.test(value)) {
          passwordErrors.push(
            <small className="mt-1 d-block">
              <FaInfoCircle /> {referencePromoCode?.errMsg.item9}
              letter.
            </small>
          );
        }
        if (!SPECIAL_CHAR_REGEX.test(value)) {
          passwordErrors.push(
            <small className="mt-1 d-block">
              <FaInfoCircle /> {referencePromoCode?.errMsg.item10}
            </small>
          );
        }
        if (value === currentPass) {
          passwordErrors.push(
            <small className="mt-1 d-block">
              <FaInfoCircle /> {referencePromoCode?.errMsg.item11}
            </small>
          );
        }
        error =
          passwordErrors.length > 0 ? (
            passwordErrors
          ) : (
            <small className="primary-color">
              <FaCheck /> {passwordtext?.okPassword}
            </small>
          );
        break;
      }
      default:
        break;
    }
    setErrors({ ...errors, [field]: error });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    // Validation rules
    const isValidFirstName = values.firstName.length >= 3;
    const isValidLastName = values.lastName.length >= 3;
    const isValidEmail = EMAIL_REGEX.test(values.email);
    const isValidPhoneNumber =
      typeof values.phoneNumber === "string" &&
      values.phoneNumber.trim() !== "";
    const isValidPassword = PASSWORD_VALIDATION_REGEX.test(values.password);

    if (
      !isValidFirstName ||
      !isValidLastName ||
      !isValidEmail ||
      !isValidPhoneNumber ||
      !isValidPassword
    ) {
      setErrors({
        firstName: isValidFirstName
          ? ""
          : profiletexts.errorMessage.firstNameRequired,
        lastName: isValidLastName
          ? ""
          : profiletexts.errorMessage.lastNameRequired,
        email: isValidEmail ? "" : referencePromoCode.errMsg.item5,
        phoneNumber: isValidPhoneNumber ? "" : referencePromoCode.errMsg.item13,
        password: isValidPassword ? "" : referencePromoCode.errMsg.item14
      });
    } else {
      try {
        const userdataentry = {
          firstName: values.firstName,
          lastName: values.lastName,
          email: values.email,
          primaryContactNumber: values.phoneNumber,
          password: values.password
        };
        const response = await publicAxios.post(`/register`, userdataentry);
        if (response.status === 200) {
          showToast(response.data.message, showToastType.success);
          setValues({ ...values, error: "" });
          navigate("/");
        } else {
          setErrors({ ...errors, submit: referencePromoCode.errMsg.item15 });
        }
      } catch {
        setErrors({ ...errors, submit: referencePromoCode.errMsg.item16 });
      }
    }
  };

  const myRef = useRef(null);
  const executeScroll = () => {
    myRef.current.scrollIntoView({
      behavior: "smooth",
      block: "start" // Aligns the top of the element to the top of the viewport
    });
  };

  const imageDisplay = useCallback(async (referralCode) => {
    try {
      const response = await publicAxios.get(getreferralImageURL(referralCode));
      const base64String = response.data.data.image;
      const fileTypeString = response.data.data.fileType;
      const description = response.data.data.partnerListingDescription;
      setImageBase64(base64String);
      setFileType(fileTypeString);
      setDescription(description);
      setNotFound(false);
    } catch {
      setNotFound(true);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    if (initialRender.current) {
      getCountryFromIP();
      getIPAddress();
      initialRender.current = false;
    }
    imageDisplay(referralCode);
  }, [ipAddress, imageDisplay, referralCode]);

  if (isLoading) return null;
  if (notFound) return <NotFound />;

  return (
    <>
      <Headerweb />
      <main>
        <section className="partnerSec cmnPadding bnr_margin">
          <div className="container-wrap">
            <div className="row">
              <div className="col-md-5 text-center">
                <div className="mainLogo">
                  <img src={companyLogo} alt="Logo" />
                </div>
                <div className="paragraph">
                  <p>{referencePromoCode.text1}</p>
                </div>
              </div>
              <div className="col-md-2 text-center">
                <div className="anSign">&</div>
              </div>
              <div className="col-md-5 text-center">
                <div className="mainLogo">
                  <img
                    src={`data:image/${fileType};base64,${imageBase64}`}
                    alt="Partner Logo"
                  />
                </div>
                <div className="paragraph">
                  <p>{description}</p>
                </div>
              </div>
            </div>
            <div className="btnSection my-5 text-center">
              <p>
                {referencePromoCode.text2} <br /> {referencePromoCode.text3}
              </p>
              <Link
                to=""
                className="btn btn-primary btn-xl"
                onClick={executeScroll}
              >
                {referencePromoCode.createAccbtn}
              </Link>
            </div>
            <div className="btnSection my-5 text-center">
              <p>
                {referencePromoCode.text4} <br /> {referencePromoCode.text5}
              </p>
              <div className="d-flex justify-content-center align-items-center">
                <Link to="" className="btn btn-primary btn-xl me-4">
                  {referencePromoCode.bookbtn}
                </Link>
                <Link to="" className="">
                  {referencePromoCode.bookbtn}
                </Link>
              </div>
            </div>
          </div>
        </section>

        <section className="pagebreaker">
          <div className="container-wrap">
            <div className="d-flex justify-content-between">
              <div className="round_img">
                <img src={HappyMan} alt="Circle Img" />
              </div>
              <div className="text_sec">
                <h2>{referencePromoCode.text6}</h2>
                <p>{referencePromoCode.text7}</p>
                <Link
                  to=""
                  className="btn btn-stroke-white btn-xl mt-3"
                  onClick={executeScroll}
                >
                  {referencePromoCode.createAccbtn}
                </Link>
              </div>
            </div>
          </div>
        </section>

        <section className="howITworks cmnPadding">
          <div className="container-wrap">
            <div className="sec_heading text-center">
              <h2>{referencePromoCode.text8}</h2>
            </div>
            <div className="row step_sec mt-5">
              <div className="col-md-4 text-center step_sec_item">
                <div className="step_icon">
                  <img src={invoice} alt="Icon" />
                </div>
                <div className="step_title">
                  <strong> {referencePromoCode.one}</strong>
                  <span> {referencePromoCode.text9}</span>
                </div>
                <div className="step_para">
                  <p>{referencePromoCode.text10}</p>
                </div>
                <div className="arrow" />
              </div>
              <div className="col-md-4 text-center step_sec_item">
                <div className="step_icon">
                  <img src={approved} alt="Icon" />
                </div>
                <div className="step_title">
                  <strong>{referencePromoCode.two}</strong>
                  <span>{referencePromoCode.text11}</span>
                </div>
                <div className="step_para">
                  <p>{referencePromoCode.text12}</p>
                </div>
                <div className="arrow" />
              </div>
              <div className="col-md-4 text-center step_sec_item">
                <div className="step_icon">
                  <img src={paid} alt="Icon" />
                </div>
                <div className="step_title">
                  <strong>{referencePromoCode.three}</strong>
                  <span>{referencePromoCode.text13}</span>
                </div>
                <div className="step_para">
                  <p>{referencePromoCode.text14}</p>
                </div>
              </div>
            </div>
            <div className="d-flex justify-content-center mt-5">
              <Link
                to=""
                className="btn btn-primary btn-xl"
                onClick={executeScroll}
              >
                {referencePromoCode.createAccbtn}
              </Link>
            </div>
          </div>
        </section>

        <section className="pagebreaker pgbkr2">
          <div className="container-wrap text-center">
            <div className="text_sec w-100">
              <h2 className="mb-3">{referencePromoCode.text15}</h2>
              <p>{referencePromoCode.text16}</p>

              <p>{referencePromoCode.text17}</p>
            </div>
          </div>
        </section>

        <section className="uspSection cmnPadding">
          <div className="container-wrap text-center">
            <div className="row">
              <div className="col-md-3 text-center usp_item">
                <div className="step_icon">
                  <img src={CashFlow} alt="Icon" />
                </div>
                <div className="usp_text">
                  <h2>{referencePromoCode.text18}</h2>
                  <p>{referencePromoCode.text19}</p>
                </div>
                <div className="arrow" />
              </div>

              <div className="col-md-3 text-center usp_item">
                <div className="step_icon">
                  <img src={FastFunds} alt="Icon" />
                </div>
                <div className="usp_text">
                  <h2>{referencePromoCode.text20}</h2>
                  <p>{referencePromoCode.text21}</p>
                </div>
                <div className="arrow" />
              </div>

              <div className="col-md-3 text-center usp_item">
                <div className="step_icon">
                  <img src={SimpleEasy} alt="Icon" />
                </div>
                <div className="usp_text">
                  <h2>{referencePromoCode.text22}</h2>
                  <p>{referencePromoCode.text23}</p>
                </div>
                <div className="arrow" />
              </div>

              <div className="col-md-3 text-center usp_item">
                <div className="step_icon">
                  <img src={InnovativeSolution} alt="Icon" />
                </div>
                <div className="usp_text">
                  <h2>{referencePromoCode.text24}</h2>
                  <p>{referencePromoCode.text25}</p>
                </div>
                <div className="arrow" />
              </div>
            </div>
          </div>
        </section>

        <section className="CstmerSuccssStories cmnPadding">
          <div className="container-wrap">
            <div className="sucss_heading text-center">
              <h2>{referencePromoCode.text26}</h2>
            </div>
            <div className="row sucss_box mt-5">
              <div className="col-md-6">
                <div className="sucss_box_item">
                  <div className="sucss_box_item_sub">
                    <h2>{referencePromoCode.text27}</h2>
                    <div className="cstmr_img">
                      <img src={sarah} alt="Customer" />
                    </div>

                    <div className="cstmr_text">
                      <p>{referencePromoCode.text28}</p>
                      <p>
                        <span>{referencePromoCode.text29}</span>
                      </p>
                    </div>
                  </div>
                  <div className="d-flex justify-content-center mt-5  mb-4">
                    <Link
                      to=""
                      className="btn btn-white btn-xl"
                      onClick={() => handleTabClick("yum")}
                    >
                      {referencePromoCode.readMore}
                    </Link>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="sucss_box_item">
                  <div className="sucss_box_item_sub">
                    <h2>{referencePromoCode.text31}</h2>
                    <div className="cstmr_img">
                      <img src={pranav} alt="Customer" />
                    </div>
                    <div className="cstmr_text">
                      <p>{referencePromoCode.text32}</p>
                      <p>
                        <span>{referencePromoCode.text33}</span>
                      </p>
                    </div>
                  </div>
                  <div className="d-flex justify-content-center mt-5 mb-4">
                    <Link
                      to=""
                      className="btn btn-white btn-xl"
                      onClick={() => handleTabClick("phoenix")}
                    >
                      {referencePromoCode.readMore}
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            <div className="sucss_box_content">
              {activeTab === "yum" && (
                <div
                  className={`customer-success-stories-content yum-tab ${activeTab === "yum" ? "opacity" : ""}`}
                >
                  <img src={yum} alt="Yum" className="floatLeft" />

                  <h3>{referencePromoCode.text34}</h3>

                  <div className="customer-success-stories-quote">
                    <img src={sarah} alt="sarah" />
                    <p>
                      <strong>{referencePromoCode.text35} </strong>
                    </p>
                    <p>
                      <span>{referencePromoCode.text29}</span>
                    </p>
                  </div>

                  <p>{referencePromoCode.text36}</p>
                  <p>{referencePromoCode.text37}</p>
                  <p>{referencePromoCode.text38}</p>
                  <div className="customer-success-stories-quote">
                    <img src={yum2} alt="" />
                  </div>
                  <p>{referencePromoCode.text39}</p>

                  <h4>{referencePromoCode.text40}</h4>

                  <p>{referencePromoCode.text41}</p>
                </div>
              )}

              {activeTab === "phoenix" && (
                <div
                  className={`customer-success-stories-content phoenix-tab ${activeTab === "phoenix" ? "opacity" : ""}`}
                >
                  <img src={pranav} alt="Yum" className="floatLeft" />

                  <h3>{referencePromoCode.text42}</h3>

                  <div className="customer-success-stories-quote">
                    <img src={pranav} alt="sarah" />
                    <p>
                      <strong>{referencePromoCode.text42}</strong>
                    </p>
                    <p>
                      <span> {referencePromoCode.text33}</span>
                    </p>
                  </div>

                  <p>{referencePromoCode.text43}</p>

                  <p>{referencePromoCode.text44}</p>

                  <p>{referencePromoCode.text45}</p>

                  <p>{referencePromoCode.text46}</p>

                  <p>{referencePromoCode.text47}</p>

                  <p>{referencePromoCode.text48}</p>

                  <p>{referencePromoCode.text49}</p>
                </div>
              )}
            </div>
          </div>
        </section>

        <section className="reffrence_signup_frm sign-up-wrap pt-0" ref={myRef}>
          <div className="container-wrap">
            <div className="col-row justify-content-center">
              <div className="right-section w-100">
                <div className="sign-up-form">
                  <div className="from_heading">
                    <h2> {referencePromoCode.text50}</h2>
                    <div className="right-head">
                      <h4>{reset_password.or}</h4>
                      <Link to={LOGIN} className="btn btn-primary">
                        {footer_web.productLink.link4}
                      </Link>
                    </div>
                  </div>
                  <form id="signup_form" onSubmit={handleSubmit}>
                    <div className="input-row">
                      <div className="left-col">
                        <div className="input-group">
                          <label htmlFor="">{profiletexts.first_name}</label>
                          <input
                            type="text"
                            placeholder="Alexan"
                            name="first_name"
                            onChange={(e) =>
                              handleInputChange("firstName", e.target.value)
                            }
                            value={values.firstName}
                          />
                          {errors.firstName && (
                            <p className="error-message">
                              <small>{errors.firstName}</small>
                            </p>
                          )}
                        </div>
                      </div>
                      <div className="right-col">
                        <div className="input-group">
                          <label htmlFor="">{profiletexts.last_name}</label>
                          <input
                            type="text"
                            placeholder="Doe"
                            name="last_name"
                            onChange={(e) =>
                              handleInputChange("lastName", e.target.value)
                            }
                            value={values.lastName}
                          />
                          {errors.lastName && (
                            <p className="error-message">
                              <small>{errors.lastName}</small>
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="input-row">
                      <div className="input-group">
                        <label htmlFor="emailAddress">
                          {adduserModal.emailAddress}
                        </label>
                        <input
                          type="email"
                          placeholder="alexandoe@example.com"
                          name="email"
                          onChange={(e) =>
                            handleInputChange("email", e.target.value)
                          }
                          value={values.email}
                        />
                        {errors.email && (
                          <p className="error-message">
                            <small>{errors.email}</small>
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="input-row">
                      <div className="input-group">
                        <label htmlFor="">{signup.signupBox.phoneNumber}</label>
                        <PhoneInput
                          inputProps={{
                            name: "phone_number"
                          }}
                          className="ph-with-country-code"
                          country={country}
                          onChange={(value) =>
                            handleInputChange("phoneNumber", value)
                          }
                          value={values.phoneNumber}
                          countryCodeEditable={false}
                          onlyCountries={["nz", "au"]}
                          areaCodes={{ au: ["61"], nz: ["64"] }}
                        />
                        {errors.phoneNumber && (
                          <p className="error-message">
                            <small>{errors.phoneNumber}</small>
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="input-row">
                      <div className="input-group">
                        <label htmlFor="">{reset_password.main_title2}</label>
                        <div className="passowrd-show">
                          <input
                            type={values.showPassword ? "text" : "password"}
                            onChange={(e) =>
                              handleInputChange("password", e.target.value)
                            }
                            value={values.password}
                            minLength={8}
                            placeholder="at least 8 characters"
                          />
                          <button
                            type="button"
                            className="password-icon"
                            onClick={handleClickShowPassword}
                          >
                            {values.showPassword ? <FaEyeSlash /> : <FaEye />}
                          </button>
                        </div>
                        {errors.password && (
                          <p className="error-message">
                            <small>{errors.password}</small>
                          </p>
                        )}
                      </div>
                    </div>

                    <div className="input-row">
                      <div className="input-group">
                        <button type="submit" className="btn-primary">
                          {referencePromoCode.createAccbtn}
                        </button>
                      </div>
                    </div>

                    {errors.submit && (
                      <p className="error-message mt-2">{errors.submit}</p>
                    )}
                  </form>
                  <div className="btm_form_text">
                    <p>{referencePromoCode.text56}</p>
                    <p>
                      {referencePromoCode.text57}
                      <Link to={MAILTO_INFO_EMAIL}>
                        {
                          reffPartner.partnermanage.mailSendModal.commisionTable
                            .email
                        }
                      </Link>
                      {referencePromoCode.text58}
                    </p>
                    <p>
                      {monthlyLending.filter.au}
                      <Link to={`tel:${auPhNumberTag}`}>
                        {
                          reffPartner.partnermanage.mailSendModal.commisionTable
                            .number1
                        }
                      </Link>
                      {reset_password?.or}
                      {monthlyLending.filter.nz}
                      <Link to={`tel:${nzPhNumberTag}`}>
                        {
                          reffPartner.partnermanage.mailSendModal.commisionTable
                            .number1
                        }
                      </Link>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footerweb />
    </>
  );
}
